const SvgPlay = () => {
  return (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none">
      <path
        d="M14.271 9.42089C14.5153 9.27985 14.6374 9.20933 14.6766 9.11625C14.7078 9.0419 14.7078 8.9581 14.6766 8.88375C14.6374 8.79067 14.5153 8.72015 14.271 8.57911L0.729 0.760633C0.48471 0.619593 0.362565 0.549072 0.2624 0.561726C0.182382 0.571835 0.109804 0.613737 0.0610409 0.67798C0 0.758398 0 0.899439 0 1.18152L0 16.8185C0 17.1006 0 17.2416 0.0610409 17.322C0.109804 17.3863 0.182382 17.4282 0.2624 17.4383C0.362565 17.4509 0.48471 17.3804 0.729 17.2394L14.271 9.42089Z"
        fill="white"
      />
    </svg>
  );
};

export default SvgPlay;
